'use strict';

module.exports = [require('./to')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/function/unit/index.js
// module id = jMJy
// module chunks = 0